import React, { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// NOTE: Assuming this import is correctly set up in your actual project structure
import fbplaceholderimg from '../../assets/images/fbplaceholder.png'; 
import { Facebook, Linkedin, Instagram, Twitter, Youtube, Image as ImageIcon, User, Bell, Sun, Target, DollarSign, Link } from "lucide-react";


// --- Custom Date Input Component (Unchanged) ---
const CustomDateInput = React.forwardRef(({ value, onClick, label, id }, ref) => (
  <div className="new-campaign-create-date-group" onClick={onClick} ref={ref}>
    {label && <label htmlFor={id}>{label}</label>}
    <input
      id={id}
      type="text"
      value={value}
      readOnly
      className="new-campaign-create-date"
    />
  </div>
));
CustomDateInput.displayName = 'CustomDateInput';

const BudgetDropdown = ({ label, options, value, onChange, placeholder }) => {

  const selectedOption = options.find(option => option.value === value);

  
  const CustomSingleValue = ({ children, ...props }) => (
    <div {...props.innerProps} className="new-campaign-create-budget-value-display">
        {children}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="new-campaign-create-budget-arrow">
            <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
    </div>
  );

  return (
    <div className="new-campaign-create-input-group">
      <label className="new-campaign-create-budget-label">{label}</label>
      <Select
        options={options}
        value={selectedOption}
        onChange={(option) => onChange(option ? option.value : '')}
        placeholder={placeholder}
        isClearable={false}
        styles={budgetSelectStyles}
        components={{
          DropdownIndicator: () => null, 
          IndicatorSeparator: () => null, 
          SingleValue: CustomSingleValue,
        }}
        classNamePrefix="budget-select" 
      />
    </div>
  );
};

const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      borderRadius: '8px',
      borderColor: '#e0e0e0',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#456EF7',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#e6eaff',
      borderRadius: '4px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#456EF7',
    }),
};


const budgetSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      borderRadius: '8px',
      borderColor: '#e0e0e0',
      boxShadow: 'none',
      cursor: 'pointer',
      padding: '0 8px',
  
    }),
    singleValue: (provided) => ({
        ...provided,
        width: '100%',
    }),

    input: (provided) => ({
        ...provided,
        height: 0,
        margin: 0,
        padding: 0,
        border: 'none',
        opacity: 0,
    }),
};


const CreateCampaign = () => {
  const [campaignName, setCampaignName] = useState("e.a, Summer 2026 Product Launch");
  const [platformToggle, setPlatformToggle] = useState(true);
  const [selectedPlatforms, setSelectedPlatforms] = useState({
    facebook: true,
    instagram: true,
    linkedin: true,
    twitter: false,
    youtube: false,
    pinterest: false,
  });
  const [postContent, setPostContent] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [startTime, setStartTime] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date(2023, 11, 20)); 
  const [endTime, setEndTime] = useState(new Date()); 
  const [previewPlatform, setPreviewPlatform] = useState("Facebook Feed"); 
  const [previewLayout, setPreviewLayout] = useState("Facebook Feed"); 
  

  const [selectedAudience, setSelectedAudience] = useState([]);
  const [conversionGoal, setConversionGoal] = useState(null);
  
  const [dailyBudgetOption, setDailyBudgetOption] = useState("250");
  const [totalBudgetOption, setTotalBudgetOption] = useState("5000"); 

  const audienceOptions = [
    { value: 'new_customers', label: 'New Customers' },
    { value: 'retargeting', label: 'Retargeting (Website)' },
    { value: 'lookalike', label: 'Lookalike Audience' },
    { value: 'geo_us_ca', label: 'Geographic: US & Canada' },
  ];

  const goalOptions = [
    { value: 'conversions', label: 'Website Conversions' },
    { value: 'reach', label: 'Max Reach' },
    { value: 'traffic', label: 'Link Clicks / Traffic' },
  ];
  

  const dailyBudgetOptions = [
      { value: '100', label: '$100 Daily' },
      { value: '250', label: '$250 Daily' },
      { value: '500', label: '$500 Daily' },
      { value: 'custom', label: 'Custom' },
  ];

  const totalBudgetOptions = [
      { value: '5000', label: '$5,000 Total' },
      { value: '10000', label: '$10,000 Total' },
      { value: '25000', label: '$25,000 Total' },
      { value: 'custom', label: 'Custom' },
  ];

  const handlePlatformToggle = (platform) => {
    setSelectedPlatforms((prev) => ({
      ...prev,
      [platform]: !prev[platform],
    }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
    }
  };


  return (
    <div className="new-campaign-create-container">


      <div className="new-campaign-create-content">
       
        <div className="new-campaign-create-left">
          {/* <h3 className="new-campaign-create-title">Campaign Details</h3> */}
          

          <div className="new-campaign-create-input-group">
             <label htmlFor="campaignNameInput">Campaign Name</label>
             <input
               id="campaignNameInput"
               type="text"
               placeholder="e.g. Summer 2026 Product Launch"
               value={campaignName}
               onChange={(e) => setCampaignName(e.target.value)}
               className="new-campaign-create-input"
             />
          </div>
          

       

       
          

          <div className="new-campaign-create-platforms-section">
            <div className="new-campaign-create-platforms-header">
              <p>Platforms</p>
              <div className="new-campaign-create-toggle-switch">
                <input
                  type="checkbox"
                  id="platform-toggle"
                  checked={platformToggle}
                  onChange={() => setPlatformToggle(!platformToggle)}
                  style={{ display: 'none' }}
                />
                <label htmlFor="platform-toggle" className={`switch-label ${platformToggle ? 'on' : 'off'}`}></label>
              </div>
            </div>

            <div className="new-campaign-create-platform-icons">
   
              <button
                onClick={() => handlePlatformToggle("facebook")}
                className={`new-campaign-create-platform-btn ${selectedPlatforms.facebook ? "active" : ""}`}
              >
                <Facebook size={18} />
              </button>
              <button
                onClick={() => handlePlatformToggle("instagram")}
                className={`new-campaign-create-platform-btn ${selectedPlatforms.instagram ? "active" : ""}`}
              >
                <Instagram size={18} />
              </button>
              <button
                onClick={() => handlePlatformToggle("linkedin")}
                className={`new-campaign-create-platform-btn ${selectedPlatforms.linkedin ? "active" : ""}`}
              >
                <Linkedin size={18} />
              </button>
                <div className="new-campaign-create-toggle-switch toggle-switch-disable-create  ">
                <input
                  type="checkbox"
                  id="platform-toggle"
                  checked={platformToggle}
                  onChange={() => setPlatformToggle(!platformToggle)}
                  style={{ display: 'none' }}
                />
                <label htmlFor="platform-toggle" className={`switch-label ${platformToggle ? 'on' : 'off'}`}></label>
              </div>
              <button disabled className="new-campaign-create-platform-btn disabled">
                <Twitter size={18} />
              </button>
              <button disabled className="new-campaign-create-platform-btn disabled">
                <Youtube size={18} />
              </button>
              <button disabled className="new-campaign-create-platform-btn disabled">
                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> 
              </button>
            </div>
          </div>


          <div className="new-campaign-create-postcontent">
            <p>Post Content</p>
            <div className="new-campaign-create-textarea-container">
              <textarea
                className="new-campaign-create-textarea"
                placeholder="Write your campaign content..."
                value={postContent}
                onChange={(e) => setPostContent(e.target.value)}
              />
              <span className="new-campaign-create-char-count">{postContent.length} / 500</span>
            </div>
          </div>

          <div className="new-campaign-create-budget-schedule-grid">
            <h4 className="new-campaign-create-budget-title">Budget & Schedule</h4>
         
            <div className="new-campaign-create-grid-item">
              <BudgetDropdown 
                label="Daily Budget" 
                options={dailyBudgetOptions}
                value={dailyBudgetOption}
                onChange={setDailyBudgetOption}
                placeholder="Select Daily Budget"
              />
            </div>

       
            <div className="new-campaign-create-grid-item-span2">
              <label>Media Upload</label>
              <div className="new-campaign-create-upload-box">
                {selectedImage ? (
                  <img src={selectedImage} alt="preview" className="new-campaign-create-image-preview" />
                ) : (
               
                  <img 
                    src={fbplaceholderimg} 
                    alt="Image Placeholder" 
                    className="new-campaign-create-image-placeholder" 
                  />
                )}
                <input type="file" accept="image/*" onChange={handleImageUpload} />
              </div>
            </div>
            
         
            <div className="new-campaign-create-grid-item">
              <BudgetDropdown 
                label="Total Budget" 
                options={totalBudgetOptions}
                value={totalBudgetOption}
                onChange={setTotalBudgetOption}
                placeholder="Select Total Budget"
              />
            </div>
   <div className="new-campaign-create-input-group">
            <label>Audience Targeting</label>
            <Select
              options={audienceOptions}
              value={selectedAudience}
              onChange={setSelectedAudience}
              placeholder="Select target audience.."
              isMulti
              styles={customSelectStyles}
              classNamePrefix="audience-select  crete-campagin-select-option-group"
            />
          </div>
           <div className="new-campaign-create-grid-item">
   <div className="new-campaign-create-input-group">
            <label>Conversion Goal</label>
            <Select
              options={goalOptions}
              value={conversionGoal}
              onChange={setConversionGoal}
              placeholder="Select campaign goal..."
              isClearable
              styles={customSelectStyles}
              classNamePrefix="goal-select crete-campagin-select-option-group" 
            />
          </div>

          
           </div>
            <div className="new-campaign-create-grid-item">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                customInput={<CustomDateInput label="End Date" id="endDate" />}
                dateFormat="yyyy MMM dd"
              />
            </div>

        
            <div className="new-campaign-create-grid-item">
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                customInput={<CustomDateInput label="Start Date" id="startDate" />}
                dateFormat="yyyy MMM dd"
              />
            </div>
            
            {/* 6. Start Time (Right Column - Unchanged) */}
            <div className="new-campaign-create-grid-item">
              <DatePicker
                selected={startTime}
                onChange={(time) => setStartTime(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                customInput={<CustomDateInput label="Start Time" id="startTime" />}
              />
            </div>

        
            <div className="new-campaign-create-grid-item">
              <DatePicker
                selected={endTime}
                onChange={(time) => setEndTime(time)}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="Time"
                dateFormat="h:mm aa"
                customInput={<CustomDateInput label="End Time" id="endTime" />}
              />
            </div>
          </div>

          {/* Action Buttons (Unchanged) */}
          <div className="new-campaign-create-buttons">
            <button className="new-campaign-create-save-btn">Save as Draft</button>
            <button className="new-campaign-create-launch-btn">Launch Campaign</button>
          </div>
        </div>

        {/* RIGHT SECTION: Live Preview (Updated Placeholder) */}
        <div className="new-campaign-create-right">
          <h3 className="new-campaign-create-preview-title">Live Preview</h3>
          
          {/* Tabs (Unchanged) */}
          <div className="new-campaign-create-preview-tabs-top">
            <button
              className={`new-campaign-create-tab ${previewPlatform === "Facebook Feed" ? "active" : ""}`}
              onClick={() => setPreviewPlatform("Facebook Feed")}
            >
              Facebook Feed
            </button>
            <button
              className={`new-campaign-create-tab ${previewPlatform === "LinkedIn Story" ? "active" : ""}`}
              onClick={() => setPreviewPlatform("LinkedIn Story")}
            >
              LinkedIn Story
            </button>
            <button className="new-campaign-create-tab disabled">
              X Post
            </button>
          </div>

          <div className="new-campaign-create-preview-tabs-inner">
            <button
              className={`new-campaign-create-tab inner-tab ${previewLayout === "Facebook Feed" ? "active" : ""}`}
              onClick={() => setPreviewLayout("Facebook Feed")}
            >
              Facebook Feed
            </button>
            <button
              className={`new-campaign-create-tab inner-tab ${previewLayout === "LinkedIn Story" ? "active" : ""}`}
              onClick={() => setPreviewLayout("LinkedIn Story")}
            >
              LinkedIn Story
            </button>
          </div>

          {/* Preview Card (Updated Placeholder) */}
      <div className="new-campaign-create-preview-box">
    <div className="new-campaign-create-preview-card">
        <div className="new-campaign-create-preview-header">
            <div className="new-campaign-create-preview-avatar"></div>
            <div>
                <p className="new-campaign-create-preview-name">Flianidion</p>
                <p className="new-campaign-create-preview-time">Tilate Daunts - <span>•</span> 🌎</p>
            </div>
            <span className="new-campaign-create-preview-more">...</span>
        </div>
        
        {selectedImage ? (
            <img src={selectedImage} alt="Preview" className="new-campaign-create-preview-img" />
        ) : (
            // >>> USING IMPORTED IMAGE PATH <<<
            <img 
                src={fbplaceholderimg} 
                alt="Preview Placeholder" 
                className="new-campaign-create-preview-img new-campaign-create-image-placeholder" 
            />
        )}
        
        <div className="new-campaign-create-preview-text">
            <h4 className="new-campaign-create-preview-post-title">Durs Llo Proop</h4>
            <p className="new-campaign-create-preview-post-content">
                {postContent || "Your campaign content here..."}
            </p>
        </div>
        
        {/* === START: Added Social Actions with Icons === */}
        <div className="new-campaign-create-social-actions">
            <button className="social-action-btn">
                {/* Like Icon */}
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjUgNUMxNC41NDkzIDUgMTIuOTk4MiA2LjUxNjk0IDEyLDEwLjA3NDVDMTAuMDAxOCAxMC4wMDE4IDguNDUwNyA1IDYuNSA1QzMuNDYyNCA1IDEuMDc3NzkgNy42NjQ1IDEuMjM5NDIgMTAuNTEwN0MxLjQzMTk4IDE0LjMxNzIgNS43MzMzIDIzLjg1NjggMTIgMjNDMjAgMjMuMzM3MSAyMi42ODMzIDE2LjQ3MDIgMjIuNzU3OCAxMi40OTk4QzIyLjg0NTggOC4xOTIxMiAxOS42MDQzIDUgMTYuNSA1WiIgc3Ryb2tlPSIjNDU2RUY3IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPg==" alt="Like" width="18" height="18" />
                Like
            </button>
            <button className="social-action-btn">
                {/* Comment Icon */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                Comment
            </button>
            <button className="social-action-btn">
                {/* Share Icon */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></svg>
                Share
            </button>
        </div>
        {/* === END: Added Social Actions with Icons === */}
    </div>
</div>
        </div>
      </div>
    </div>
  );
};

export default CreateCampaign;